import React from 'react';
import { DEFAULT_USER_AVATAR, SENSITIVE_USER_AVATAR } from '../utils/avatarAssets';
import { framePhotoStyle } from '../utils/frameFit';

// Keep frames as native images: animated GIF/WebP must never pass through canvas.
export default function FramedAvatar({ src, alt = '', frameUrl, frameBorderRadius, frameFit, size = 40, sensitive = false }) {
  const [failedFrame, setFailedFrame] = React.useState(null);
  const [failedImage, setFailedImage] = React.useState(null);
  const framed = Boolean(frameUrl && failedFrame !== frameUrl);
  return <span className="framed-avatar" style={{ position: 'relative', display: 'inline-block', flexShrink: 0, verticalAlign: 'middle', width: size, height: size, overflow: 'visible' }}>
    <img alt={alt} src={sensitive ? SENSITIVE_USER_AVATAR : !src || failedImage === src ? DEFAULT_USER_AVATAR : src}
      style={{ display: 'block', objectFit: 'cover', ...framePhotoStyle(framed ? frameFit : { inset: 0 }, framed ? frameBorderRadius || '10%' : '50%') }}
      onError={() => { if (!sensitive && src && failedImage !== src) setFailedImage(src); }} />
    {framed && <img src={frameUrl} alt="" aria-hidden="true" onError={() => setFailedFrame(frameUrl)}
      style={{ position: 'absolute', display: 'block', inset: 0, width: '100%', height: '100%', objectFit: 'contain', pointerEvents: 'none' }} />}
  </span>;
}
